import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';

class CartaPorteMercanciaDocumentacionAduaneraForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidMount() {
    const TipoDocumento = CartaPorteCatalogoManager.get('c_cp_documento_aduanero');

    let catalogos = {};

    catalogos.TipoDocumento = this.getCatalogo(TipoDocumento);

    this.setState({
        catalogos
      });
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true
      });
    }
  }


  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: item.descripcion,
          value: item.clave
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  rules(data) {
    return {
      TipoDocumento: ['required', 'numeric', 'min:0.000001'],
      NumPedimento: ['string', 'max:21', 'regex:/^[0-9]{2}  [0-9]{2}  [0-9]{4}  [0-9]{7}$/'],
      IdentDocAduanero: ['string', 'min:1', 'max:150', 'regex:/^[^|]{1,150}$/'],
      RFCImpo: ['string', 'min:12', 'max:13', 'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/'],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      documentacion_aduanera: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const { isValid, data = {}, catalogos = {} } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="select"
              label="TipoDocumento"
              name="TipoDocumento"
              placeholder=""
              help=""
              rules={ rules.TipoDocumento }
              value={ data.TipoDocumento }
              options={ catalogos.TipoDocumento }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de Pedimento"
              name="NumPedimento"
              placeholder=""
              help="22  22  4444  7777777"
              maxLength="21"
              rules={ rules.NumPedimento }
              value={ data.NumPedimento }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Identificador Documento Aduanero"
              name="IdentDocAduanero"
              placeholder=""
              help=""
              minLength="1"
              maxLength="150"
              rules={ rules.IdentDocAduanero }
              value={ data.IdentDocAduanero }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="RFC del Importador"
              name="RFCImpo"
              placeholder=""
              help=""
              casing={ 'upper' }
              minLength="12"
              maxLength="13"
              rules={ rules.RFCImpo }
              value={ data.RFCImpo }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Documentación Aduanera
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteMercanciaDocumentacionAduaneraForm;